import React, { Fragment } from 'react';
import { capitalize } from '../../../utils/Helpers';
import FormError from './FormError';

const FormSelect = (props) => {
    const { label, value, handleChange, classes, name, error, options } = props;

    return (
        <Fragment>
            {label ? <label>{label}</label> : ''}
            <select className={classes} name={name} value={value} onChange={(e) => handleChange(e)}>
                <option value="" disabled>{`Select ${label}...`}</option>
                {options.map((opt, i) => (
                    <option key={opt.id || i} value={opt.id || opt}>
                        {opt.name || opt.type || capitalize(opt)}
                    </option>
                ))}
            </select>
            <FormError error={error} />
        </Fragment>
    );
};

export default FormSelect;
